import { SUPPORTED_LOCALES, type Locale } from './types';

const LOCALE_STORAGE_KEY = 'preferred-locale';

/** BCP 47 locale tags used for Intl date/number formatting */
export const LOCALE_BCP47_MAP: Record<Locale, string> = {
  en: 'en-GB',
  de: 'de-DE',
  bg: 'bg-BG',
};

/**
 * Determine the initial locale by checking, in order:
 * 1. localStorage persisted preference
 * 2. Browser navigator.language (first segment)
 * 3. Default to 'en'
 */
export function getInitialLocale(): Locale {
  const stored = localStorage.getItem(LOCALE_STORAGE_KEY);
  if (stored && (SUPPORTED_LOCALES as readonly string[]).includes(stored)) {
    return stored as Locale;
  }

  const browserLang = navigator.language.split('-')[0];
  if ((SUPPORTED_LOCALES as readonly string[]).includes(browserLang)) {
    return browserLang as Locale;
  }

  return 'en';
}

/** Persist the user's locale choice to localStorage */
export function persistLocale(locale: Locale): void {
  localStorage.setItem(LOCALE_STORAGE_KEY, locale);
}
